var path = '/static/assets/khapps/settings_v2/general/user_settings/user-settings-dialog.html';
var html = "<user-settings-dialog></user-settings-dialog>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;